module.exports = __webpack_public_path__ + "static/media/9.c4ec0b6d.jpg";